import { render, staticRenderFns } from "./FormulaAdmissionScoreCoefficientSave.vue?vue&type=template&id=084e35f3&scoped=true&"
import script from "./FormulaAdmissionScoreCoefficientSave.vue?vue&type=script&lang=js&"
export * from "./FormulaAdmissionScoreCoefficientSave.vue?vue&type=script&lang=js&"
import style0 from "./FormulaAdmissionScoreCoefficientSave.vue?vue&type=style&index=0&id=084e35f3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084e35f3",
  null
  
)

export default component.exports